import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

class PrivateRoute extends React.Component {
  setRoute = (props, Component) => {
    if (this.props.firebaseAuth.isEmpty !== true) {
      return <Component {...props} />;
    } else {
      return (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      );
    }
  };

  render() {
    const { component: Component, ...rest } = this.props;

    return (
      <Route {...rest} render={props => this.setRoute(props, Component)} />
    );
  }
}

const mapStateToProps = state => {
  return {
    firebaseAuth: state.firebase.auth,
    firebaseProfile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(PrivateRoute);
